import React, { createContext, useContext, useReducer } from 'react';
import { ICessionContext } from './cession.interfaces';
import { cessionInitialState, cessionReducer } from './cessionReducer';

export const CessionContext = createContext<ICessionContext | undefined>(
  undefined,
);

export interface ICessionProviderProps {
  children?: React.ReactNode;
}

export const CessionProvider = ({ children }: ICessionProviderProps) => {
  const [state, dispatch] = useReducer(cessionReducer, cessionInitialState);

  const value = { state, dispatch };
  return (
    <CessionContext.Provider value={value}>{children}</CessionContext.Provider>
  );
};

export const useCessionContext = () => {
  const context = useContext(CessionContext);

  if (context === undefined) {
    throw new Error('useCessionContext must be used within a CessionProvider');
  }
  return context;
};
